import { render, staticRenderFns } from "./needSignList.vue?vue&type=template&id=48cf8a58&scoped=true"
import script from "./needSignList.vue?vue&type=script&lang=js"
export * from "./needSignList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf8a58",
  null
  
)

export default component.exports